import { Lock } from "components/icons/generated";
import Timestamp from "components/Timestamp";
import Callout from "ds/components/Callout";

type StackLockNoticeProps = {
  lockedBy: string | null;
  lockedAt?: number | null;
  viewer: string;
};

const StackLockNotice = ({ lockedAt, lockedBy, viewer }: StackLockNoticeProps) => {
  return (
    <Callout variant="warning" icon={Lock}>
      This stack was locked for exclusive use by {lockedBy === viewer ? "yourself" : lockedBy}
      {lockedAt && (
        <>
          &nbsp;on&nbsp;
          <Timestamp timestamp={lockedAt} />
        </>
      )}
      .
    </Callout>
  );
};

export default StackLockNotice;
